import React, { useContext, useMemo, useState } from 'react';
import { TimeRangeContext } from "../../../context/TimeRangeContext";

import Skeleton from 'react-loading-skeleton';

// Helper.
import Helper from '../../../helpers/Helper';

import HostApi from "../../../api/host/HostApi";

function PeakStatistic(props: { hostId: number, statistic: string, metric: number | null }) {
    const [previousMetric, setPreviousMetric] = useState<number | null>(null);
    const [differenceMetric, setDifferenceMetric] = useState<number | null>(null);
    const timeRangeContext = useContext(TimeRangeContext)

    useMemo(() => {

        const getStatistic = async() => {

            let previousData: number[] = [],
                previousPeak: number = 0;

            const responseData = await HostApi.getHostStatisticTime(timeRangeContext.getTimeRangeQueryString(true), props.hostId, props.statistic);
            for (let index = 0; index < responseData.length; index++) {
                previousData.push(responseData[index].avg);
            }
            previousPeak = Math.round(Helper.getPeakValue(previousData));

            setPreviousMetric(previousPeak);
            setDifferenceMetric(Helper.getPercentageDifference(props.metric, previousPeak));
        }

        const comparisonSupported = Helper.isComparisonSupported(timeRangeContext)
        if (comparisonSupported) {
            getStatistic();
        }

    }, [timeRangeContext, props.hostId, props.statistic, props.metric]);

    return (
        props.metric === null ? (
            <Skeleton/>
        ) : (
            <React.Fragment>
                <span className="table-metric-value">
                    {Math.round(props.metric)}%
                </span>
                {previousMetric !== null && previousMetric !== Infinity && previousMetric !== -Infinity && (
                    <span className="comparison">
                        {previousMetric}%
                        {differenceMetric !== null && (
                            <span>({differenceMetric}%)</span>
                        )}
                        {props.metric === previousMetric ? (
                            <i className="fal fa-equals fa-fw equals"/>
                        ) : (
                            props.metric > previousMetric ? (
                                <i className="fal fa-long-arrow-up fa-fw increase"/>
                            ) : (
                                <i className="fal fa-long-arrow-up fa-fw decrease"/>
                            )
                        )}
                    </span>
                )}
            </React.Fragment>
        )
    );
}

export default PeakStatistic;